import React, { useCallback } from 'react';

//Components
import Popover from '@mui/material/Popover';
// import Typography from "@mui/material/Typography";
import { IconButton } from '@mui/material';
import { MoreVert } from '@mui/icons-material';

const moreVertIcon = <MoreVert sx={{ fontSize: '24px' }} />;

export const PopoverActions = React.memo(function (props) {
  const { children } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(event => {
    setAnchorEl(null);
  }, []);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <IconButton disableRipple onClick={handleClick}>
        {moreVertIcon}
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {children({
          onClick: handleClose,
        })}
      </Popover>
    </div>
  );
});
